var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      style: { flexGrow: 1, position: "relative", marginBottom: 0 },
      attrs: { shrink: "" },
    },
    [
      _c(
        "w-col",
        {
          staticClass: "max-height",
          style: { heigth: "100%" },
          attrs: { xs: "12" },
        },
        [
          _c(
            "w-card",
            { staticClass: "root" },
            [
              _c(
                "w-card-content",
                [
                  _c("app-product-edit-row", {
                    attrs: { "sale-edit-state": _vm.state },
                    on: { "scroll-to-bottom": _vm.scrollBottom },
                  }),
                ],
                1
              ),
              _c("app-products-table", {
                attrs: { state: _vm.state },
                on: { "add-subtotal": _vm.addSubtotal },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }